import useRequest from '@/websdk/utils/request';

export default (function () {
  const { data, isRequestSuccessed } = useRequest({
    url: '/api/machines?page_no=0&page_size=0&show_param_id=true&orders=asc&order_by=sn&machine_types=IM&show_line=true',
    name: 'GET_MACHINES_ONE_PAGE',
    method: 'GET',
  });
  return [data || {}, isRequestSuccessed];
});
